import { MappedRoute } from 'hooks/use-search-menu';

import CollapsibleComponent from './components/collapsible-component';
import LinkComponent from './components/link-component';

interface Props {
  route: MappedRoute;
  depth: number;
  isOpen: boolean;
}

export default function NavigationComponent(props: Props) {
  const { route, depth } = props;
  if (route.subNav) {
    return (
      <CollapsibleComponent
        isOpen={props.isOpen}
        route={props.route}
        depth={depth}
      />
    );
  }
  return <LinkComponent route={props.route} depth={depth} />;
}
